
export default function NoPage()
{
    return <>
        <div>404 NOT FOUND</div>
    </>
}